import { useState } from "react";

import { PasswordInput, Button } from "@newsela/angelou";

import { ResetPasswordPayload } from "../MyOwnPasswordReset/MyOwnPasswordReset";
import { OnResetPasswordReturn } from "../ResetAccountPassword";
import {
  inputsGridContainerCss,
  gridWideInputWrapperCss,
  resetPasswordButtonCss,
} from "./HardPasswordReset.style";

export interface HardPasswordResetProps {
  onResetPasswordSubmit: (
    payload: Pick<ResetPasswordPayload, "newPassword">,
  ) => OnResetPasswordReturn;
  minPasswordLength: number;
  canEdit: boolean;
}

const HardPasswordReset = ({
  minPasswordLength,
  onResetPasswordSubmit,
  canEdit,
}: HardPasswordResetProps) => {
  const LENGTH_TEXT = `Must be at least ${minPasswordLength} characters long`;
  const [newPassword, setNewPassword] = useState("");
  const [controlTouched, setControlTouched] = useState(false);

  const handleResetPasswordClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    void onResetPasswordSubmit({ newPassword });
    setNewPassword("");
    setControlTouched(false);
  };

  return (
    <section>
      <form role="form">
        <div css={inputsGridContainerCss}>
          <div css={gridWideInputWrapperCss}>
            <PasswordInput
              name="password"
              label="New password"
              placeholder="Start typing..."
              helperText={
                !(controlTouched && newPassword.length < minPasswordLength)
                  ? LENGTH_TEXT
                  : ""
              }
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);
              }}
              onBlur={() => {
                if (!controlTouched) {
                  setControlTouched(true);
                }
              }}
              touched={controlTouched}
              error={
                controlTouched && newPassword.length < minPasswordLength
                  ? LENGTH_TEXT
                  : ""
              }
              disabled={!canEdit}
              autocomplete="off"
              underInputId="password-input-notification-id"
            />
          </div>
          <Button
            flavor={Button.flavors.primary}
            disabled={!canEdit || newPassword.length < minPasswordLength}
            onClick={handleResetPasswordClick}
            __cssFor={{ root: resetPasswordButtonCss }}
            type="submit"
          >
            Reset password
          </Button>
        </div>
      </form>
    </section>
  );
};

export default HardPasswordReset;
